var impressum = "Impressum";
var privacy = "Confidențialitate și juridic";
var recallInfo = "Informații despre rechemare";
var signOut = "Deconectare";
var ro_ro = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { ro_ro as default, impressum, privacy, recallInfo, signOut };
